import React, { useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";

const DestinationsSection = () => {
  const [activeCard, setActiveCard] = useState(1);
  const [tourData, setTourData] = useState([]);
  const naviagte = useNavigate();
 

  const fetchToursData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/tour-details/get-all`,
      );
      setTourData(response?.data?.tours);
      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchToursData();
  }, []);

  return (
    <div className="my-10">
      <section className="relative lg:py-10 sm:py-8 py-6 px-4 sm:px-8 lg:px-20 overflow-hidden">
        {/* Background Images with Transition */}
        <div className="absolute inset-0 z-0">
          {tourData?.map((domestic) => (
            <div
              key={domestic._id}
              className={`absolute inset-0 bg-cover bg-center transition-opacity duration-700 ${
                activeCard === domestic._id ? "opacity-100" : "opacity-0"
              }`}
              style={{ backgroundImage: `url(${domestic?.images?.[0]})` }}
            />
          ))}
          {/* Dark Overlay */}
          <div className="absolute inset-0 bg-black/50" />
        </div>

        <div className="container relative z-10 mx-auto px-4">

          <div className="flex flex-wrap items-start -mx-4">
            {/* Left Column - Description */}
      <div className="xl:w-1/3 w-full px-4">
              <div className=" relative after:absolute after:top-full after:right-[20%] after:w-px xl:after:h-100 after:h-60 after:bg-white/50 max-xl:after:hidden">
              <div className="xl:mb-5 sm:mb-5 mb-2.5">
            <h2 className="md:text-2xl text-white font-bold">DOMESTIC TOURS</h2>
          </div>
                <p className="md:text-xl sm:text-lg text-sm font-medium text-white lg:mb-5 sm:mb-5 mb-2.5">
                  Experience the Perfect Blend of Comfort and Nature, Crafted
                  for Your Ultimate Escape.
                </p>
                <button
                  onClick={() => naviagte(`/tour`)}
                  className="px-8 py-3 bg-[#d4ff00] text-black font-semibold rounded-full hover:bg-[#c4ef00] transition-colors duration-300"
                >
                  View All
                </button>
              </div>
            </div>

            {/* Right Column - Destination Cards */}
            <div className="xl:w-2/3 w-full px-4 mt-4 sm:mt-0">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {tourData
                  .filter((domestic) => domestic?.tourType?.name === "Domestic")
                  .slice(0, 4)
                  .map((domestic) => (
                    <div
                      key={domestic?._id}
                      className="relative group cursor-pointer"
                      onMouseEnter={() => setActiveCard(domestic?._id)}
                      onClick={() => naviagte(`/tour-details/${domestic?._id}`)}
                    >
                      {/* Card Image */}
                      <div className="relative overflow-hidden rounded-3xl">
                        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/60 z-10" />
                        <img
                          src={domestic?.images?.[0]}
                          alt={domestic?.name}
                          className="w-full h-[300px] object-cover transition-transform duration-500 group-hover:scale-110"
                        />
                      </div>

                      {/* Card Content */}
                      <div className="absolute left-0 bottom-0 sm:p-6 p-4 flex items-center justify-between w-full z-20">
                        <div className="flex-1">
                          <h3 className="text-lg font-medium text-white max-w-[300px] uppercase mb-2 line-clamp-1">
                            {domestic?.name}
                          </h3>
                          <span
                            className={`text-sm font-semibold uppercase transition-colors duration-500 ${
                              activeCard === domestic._id
                                ? "text-[#d4ff00]"
                                : "text-white/50"
                            }`}
                          >
                            {domestic?.location}
                          </span>
                        </div>

                        {/* Arrow Button - Only visible on hover */}
                        <div className="ml-4">
                          <a
                            href="trip-details.html"
                            aria-label="View trip details"
                            className={`size-12 w-12 h-12 flex items-center justify-center rounded-full bg-[#d4ff00] transition-all duration-500 ${
                              activeCard === domestic?._id
                                ? "translate-x-0 rotate-0 opacity-100"
                                : "xl:-translate-x-full xl:rotate-[-360deg] xl:opacity-0 opacity-100"
                            }`}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5 12H19"
                                stroke="black"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12 5L19 12L12 19"
                                stroke="black"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DestinationsSection;
